export enum Role {
  User = 'user',
  Admin = 'admin',
}

export const AdminKeycloakRole = { roles: [`realm:${Role.Admin}`] };
